<div class="sidenav-content">
	<div class="card-block-padding card-title-block">
		<copo-back-button></copo-back-button>
		<div class="card-title-label" translate>fast.lane.entry</div>
	</div>
</div>